import { UploadTranscript } from "@/components/UploadTranscript";

export function UploadPage() {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <UploadTranscript />
    </div>
  );
}
